import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { Header } from '../components/Header';
export const BaseLayout = ({ children }) => {
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            overflow: 'hidden',
        }, children: [_jsx(Header, {}), _jsx(Box, { component: "main", sx: theme => ({
                    width: '100%',
                    pt: { xs: theme.spacing(2), md: theme.spacing(5) },
                    flex: 1,
                    display: 'flex',
                }), children: _jsx(Box, { sx: theme => ({
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: theme.spacing(4),
                        px: { xs: 2, md: 12 },
                        py: theme.spacing(6),
                    }), children: children }) })] }));
};
